// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Mk3B","dot":"styles_dot__9LsIW","bounce":"styles_bounce__wl-ZB"};